import { api } from './client';

export interface AuthorityConfigDto {
  id: number;
  workflowName: string;
  authorityLevel: string;
  description: string;
  updatedAt: string | null;
  updatedBy: string | null;
}

export interface CloseReadinessDto {
  overallScore: number;
  bankMatchPercentage: number;
  invoicePostPercentage: number;
  unresolvedAlertsCount: number;
  missingAccrualsEstimate: number;
  criticalCount: number;
  warningCount: number;
  blockers: string[];
}

export interface ExceptionsCountDto {
  count: number;
}

export const aiAuthorityApi = {
  getConfigs: () =>
    api.get<AuthorityConfigDto[]>('/ai/authority-config'),

  updateConfig: (workflowName: string, authorityLevel: string) =>
    api.put(`/ai/authority-config/${workflowName}`, { authorityLevel }),
};

export const closeReadinessApi = {
  get: () =>
    api.get<CloseReadinessDto>('/close-readiness'),
};

export const exceptionsApi = {
  get: (skip = 0, take = 50) =>
    api.get('/exceptions', { skip, take }),

  getCount: () =>
    api.get<number>('/exceptions/count'),

  approve: (id: string, reviewerId: string) =>
    api.post(`/exceptions/${id}/approve`, { reviewerId }),

  reject: (id: string, reviewerId: string) =>
    api.post(`/exceptions/${id}/reject`, { reviewerId }),
};
